/* istanbul ignore file */
import React, { useState } from 'react';
import { useShowContext } from 'framework/show';
import NewQualificationMenu from 'domain/people/career/qualification/newCompetency/shared/NewQualificationMenu';
import {
  NewCompetencyType,
  NewCompetencyTypeLabels,
} from 'domain/people/career/qualification/newCompetency/newCompetencyService';
import NewCompetencyQualificationModel from 'domain/people/career/qualification/newCompetency/Show/NewCompetencyQualificationModel';

const NewQualificationModel = () => {
  const { data: competencies } = useShowContext();
  const [currentType, setCurrentType] = useState(NewCompetencyType.ORGANIZATIONAL);
  const currentData = competencies.data?.filter((comp: { type: any }) => String(comp.type) === String(currentType));

  return (
    <>
      <NewQualificationMenu setCurrentType={setCurrentType} currentType={currentType} />
      <NewCompetencyQualificationModel data={currentData} title={NewCompetencyTypeLabels[currentType]} />
    </>
  );
};

export default NewQualificationModel;
